//for the 2% of browsers that support modules but not dynamic imports: https://caniuse.com/#feat=es6-module-dynamic-import
import dynamicImportPolyfill from 'dynamic-import-polyfill';
dynamicImportPolyfill.initialize();

import simActivate from './sim_activations/sim-activate.svelte';
const app = new simActivate({
	target: document.getElementById('svelte'),
	props: {
	}
});
